/**
 * @desc plm批量保存或者更新物料
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(
  body: Array<defs.basics.PlmMaterialCreateRequestDto>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/plm/batchCreateOrUpdateMaterial`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
